import { combineReducers } from 'redux'

import { reducers as auth } from '../containers/Auth/store'
import { reducers as search } from '../containers/Search/store'
import { reducers as settings } from '../containers/PrinterSetup/store'
import shared from './shared/reducers'

import { loadingBarReducer } from 'react-redux-loading-bar'
import ManagementAdmin from '../containers/Management/Admin/store/reducers'

export default combineReducers({
  auth,
  shared,
  search,
  settings,
  loadingBar: loadingBarReducer,
  management_admin: ManagementAdmin
})


// WEBPACK FOOTER //
// ./src/store/rootReducers.js